import { render, staticRenderFns } from "./DocumentDetailList3.vue?vue&type=template&id=67020bcc&scoped=true"
import script from "./DocumentDetailList3.vue?vue&type=script&lang=js"
export * from "./DocumentDetailList3.vue?vue&type=script&lang=js"
import style0 from "./DocumentDetailList3.vue?vue&type=style&index=0&id=67020bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67020bcc",
  null
  
)

export default component.exports